var youbora = require('youboralib')
var manifest = require('../manifest.json')

youbora.adapters.Hlsjs = youbora.Adapter.extend({
  /** Override to return current plugin version */
  getVersion: function () {
    return manifest.version + '-' + manifest.name + '-' + manifest.tech
  },

  /** Override to return current playhead of the video */
  getPlayhead: function () {
    if (this.tag) {
      return this.tag.currentTime
    }
    return null
  },

  /** Override to return current playrate */
  getPlayrate: function () {
    if (this.tag) {
      return this.tag.playbackRate
    }
    return null
  },

  /** Override to return dropped frames since start */
  getDroppedFrames: function () {
    if (this.tag) {
      return this.tag.webkitDroppedFrameCount
    }
    return null
  },

  /** Override to return video duration */
  getDuration: function () {
    if (this.tag && !this.getIsLive()) {
      return this.tag.duration
    }
    return null
  },

  /** Override to return current bitrate */
  getBitrate: function () {
    if (this.player.currentLevel != -1 && this.player.levels[this.player.currentLevel]) {
      return this.player.levels[this.player.currentLevel].bitrate
    }
    return null
  },

  /** Override to return rendition */
  getRendition: function () {
    if (this.player.currentLevel != -1) {
      var level = this.player.levels[this.player.currentLevel]
      if (level) {
        if (level.name) {
          return level.name
        } else {
          if (level.bitrate) {
            return youbora.Util.buildRenditionString(level.width, level.height, level.bitrate)
          }
          return null
        }
      }
    }
    return null
  },

  /** Override to return true if live and false if VOD */
  getIsLive: function () {
    if (this.player.levels[this.player.currentLevel]) {
      return this.player.levels[this.player.currentLevel].details.live
    }
    return null
  },

  /** Override to return resource URL. */
  getResource: function () {
    return this.player.url
  },

  /** Override to return player version */
  getPlayerVersion: function () {
    return Hls.version
  },

  /** Override to return player's name */
  getPlayerName: function () {
    return 'Hls.js'
  },

  /** Register listeners to this.player. */
  registerListeners: function () {
    if (!this.mediaFound) {
      // Enable playhead monitor (buffer = true, seek = false)
      this.monitorPlayhead(true, true)

      this.hlsMediaReference = this.getTagListener.bind(this)
      this.player.on(Hls.Events.MEDIA_ATTACHED, this.hlsMediaReference)
    } else {
      // References
      this.references = []
      this.references['play'] = this.playListener.bind(this)
      this.references['pause'] = this.pauseListener.bind(this)
      this.references['playing'] = this.playingListener.bind(this)
      this.references['error'] = this.errorListener.bind(this)
      this.references['ended'] = this.endedListener.bind(this)
      this.hlsReference = this.hlsErrorListener.bind(this)

      // Register listeners
      for (var key in this.references) {
        this.tag.addEventListener(key, this.references[key])
      }

      this.player.on(Hls.Events.ERROR, this.hlsReference, this)
    }
  },

  /** Unregister listeners to this.player. */
  unregisterListeners: function () {
    // Disable playhead monitoring
    this.monitor.stop()

    // unregister listeners
    if (this.player && this.references) {
      this.player.off(Hls.Events.ERROR, this.hlsReference, this)
      this.player.off(Hls.events.MEDIA_ATTACHED, this.hlsMediaReference)
      if (this.tag) {
        for (var key in this.references) {
          this.tag.removeEventListener(key, this.references[key])
        }
        this.references = []
      }
    }
  },

  /** Listener for 'play' event. */
  playListener: function (e) {
    this.fireStart()
  },

  /** Listener for 'pause' event. */
  pauseListener: function (e) {
    this.firePause()
    this.pauseStamp = e.timeStamp
  },

  /** Listener for 'playing' event. */
  playingListener: function (e) {
    var thisStamp = e.timeStamp
    if (this.flags.isPaused) {
      if (this.chronos.pause.getDeltaTime() <= 0) {
        this.fireResume()
        this.fireBufferBegin()
      } else if (this.chronos.pause.getDeltaTime() <= 100
        && this.pauseStamp != thisStamp) {
        this.fireSeekBegin()
        this.fireSeekEnd()
      }
    }
    this.fireJoin()
    this.fireBufferEnd()
    this.fireSeekEnd()
    this.fireResume()
  },

  /** Listener for 'error' event. */
  errorListener: function (e) {
    this.fireError(this.tag.error.code, "PLAY FAILURE")
  },

  /** Listener for 'ended' event. */
  endedListener: function (e) {
    this.fireStop()
  },

  /** Listener for 'error' hls event. */
  hlsErrorListener: function (event, error) {
    if (error.fatal) {
      this.fireError(error.details, "PLAYER FAILURE")
      this.fireStop()
    }
  },

  getTagListener: function () {
    this.tag = this.player.media
    this.mediaFound = true
    this.registerListeners()
  }
})

module.exports = youbora.adapters.Hlsjs



//////////////////
// WEBPACK FOOTER
// ./src/adapter.js
// module id = 25
// module chunks = 0